import React from 'react';
import cx from 'classnames';

import ValuePropsSection from '@marketing/sections/value_props';

import styles from './style.module.scss';

interface Props {
  examName: string;
  header: string | React.ReactNode;
  subHeader: string;
  valueProps: {
    description: string;
    icon: string;
    name: string;
  }[];
}

export default (props: Props) => {
  const firstRowValueProps = props.valueProps.slice(0, 3);
  const secondRowValueProps = props.valueProps.slice(3);

  return (
    <div className="d-flex flex-column gap-l">
      <div className="d-flex flex-column gap-m">
        <h1 className={cx('u-margin-A-n text-bold text-center text-gray-darker', styles.heroHeader)}>
          {props.header}
        </h1>

        <div className="text-center text-inter" style={{ fontSize: 18 }}>
          {props.subHeader}
        </div>
      </div>

      <ValuePropsSection valueProps={props.valueProps} />
    </div>
  );
};
